import React, { useState, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import BackToTopButton from "./components/BackToTopButton";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Page Components
import Home from './pages/Home';
import Markets from './pages/Markets';
import Products from './pages/Products';
import Technology from './pages/Technology';
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import News from './pages/News';
import SeedFinancing from './pages/SeedFinancing';
import BreakthroughFunding from './pages/Breakthrough_funding';

// ScrollToTop component - scrolls to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isScreenTooSmall, setIsScreenTooSmall] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsScreenTooSmall(window.innerWidth <= 1150);
    };

    // Check initially
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // if (isScreenTooSmall) {
  //   return <ScreenSizeWarning />;
  // }

  return (
    <HelmetProvider>
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/products" element={<Products />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/seed-financing" element={<SeedFinancing />} />
              <Route
                path="/news/breakthrough-funding"
                element={<BreakthroughFunding />}
              />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
